import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Keeps the <html lang> attribute in sync with the active i18next language.
 * Mount once at the app root.
 */
export function useHtmlLang() {
  const { i18n } = useTranslation()

  useEffect(() => {
    const lang = i18n.language?.slice(0, 2) ?? 'en'
    document.documentElement.lang = lang
  }, [i18n.language])
}
